import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    centerMode: true,
    centerPadding: "20px",
    responsive: [
        {
            breakpoint: 1024,
            settings: { slidesToShow: 2, centerPadding: "15px" },
        },
        {
            breakpoint: 760,
            settings: { slidesToShow: 1, centerPadding: "10px" },
        },
    ],
};

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabbannerlist: [],
        }
    }

    componentDidMount() {
        const cacheKey = "tabBannerListCache";
        const cacheTTL = 3 * 60 * 60 * 1000;
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));
        if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
            this.setState({ tabbannerlist: cachedData.data });
        } else {
            instance.get("/api/v1/tabbannerlist?System=" + Systems)
                .then((res) => {
                    if (res.data.status === 200) {
                        this.setState({ tabbannerlist: res.data.message });
                        localStorage.setItem(cacheKey, JSON.stringify({
                            timestamp: Date.now(),
                            data: res.data.message,
                        }));
                    }
                }).catch((err) => {
                    console.error("Error fetching tabbannerlist:", err);
                });
        }
    }

    render() {
        const { tabbannerlist } = this.state
        return (
            <>
                <div className="px-0 card-width-banner" data-v-8a7c0ea5="">
                    <div
                        className="flicking-viewport"
                        data-v-8a7c0ea5=""
                        style={{ userSelect: "none", WebkitUserDrag: "none", touchAction: "pan-y" }}
                    >
                        <Slider {...settings}>
                            {tabbannerlist.map((item, index) => (
                                <div key={index}>
                                    <img
                                        src={item?.path}
                                        alt={"Slide " + index}
                                        style={{ borderRadius: "0.5rem", width: "100%" }}
                                    />
                                </div>
                            ))}
                        </Slider>
                        <div className="flicking-pagination flicking-pagination-bullets" data-v-8a7c0ea5="" />
                    </div>
                </div>
            </>
        );
    }
}
export default App;
